import React, { useState, useEffect, useRef } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
// import { TailSpin } from "react-loader-spinner";
import Select from "react-select";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Style.css";
import { TailSpin } from "react-loader-spinner";
import QuestionReply from "../../Components/Admin_components/questionReply.js";
import "../../Api/apiUrls";
import { getAdminQuestion } from "../../Api/apiUrls";

function Question() {
  const [question, setQuestion] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [modalQuestionReplyIsOpen, setQuestionReplyModalIsOpen] = useState("");
  const [questionId, setQuestionId] = useState("");

  const openQuestionReply = (questionId) => {
    setQuestionId(questionId);
    closeQuestionReply();
    setQuestionReplyModalIsOpen(true);
  };
  const closeQuestionReply = () => {
    setQuestionReplyModalIsOpen(false);
  };
  const type = [
    { value: "All", label: "All" },
    { value: "Workshop", label: "Workshop" },
    { value: "Venue", label: "Venue" },
    { value: "News", label: "News" },
  ];
  const [selectedType, setSelectedType] = useState(null);
  useEffect(() => {
    const hasReloaded = localStorage.getItem('hasReloaded');
    if (!hasReloaded) {
      // alert("hiiiiiiiiiii")
      localStorage.setItem('hasReloaded', 'true');
      window.location.reload();
    }
  }, []);
  useEffect(() => {
    fetch(getAdminQuestion)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const question = data.data.Questions;
        console.log(question);
        setQuestion(question);
      })
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => {
        setIsLoading(false);
        console.log("Question value:", question);
      });
  }, []);

  const formatCreatedAt = (createdAt) => {
    const createdAtDate = new Date(createdAt);
    return createdAtDate.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };
  const [searchQuery, setSearchQuery] = useState("");

  const filteredQuestions = Array.isArray(question)
    ? question.filter((question) => {
        const isTypeMatch =
          !selectedType ||
          selectedType.value === "All" ||
          question.question_for === selectedType.value;
        const values = Object.values(question).map((value) =>
          typeof value === "string" ? value.toLowerCase() : ""
        );
        const isSearchMatch = values.some((value) =>
          value.includes(searchQuery.toLowerCase())
        );
        return isTypeMatch && isSearchMatch;
      })
    : [];
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  return (
    <div>
      {modalQuestionReplyIsOpen && (
        <QuestionReply onClose={closeQuestionReply} questionId={questionId} />
      )}
      <Header></Header>

      <main id="main" class="main">
        <div class="pagetitle">
          <h1> Question</h1>
          {/* <nav>
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="/categories">Home</a>
              </li>
              <li class="breadcrumb-item active">Question</li>
            </ol>
          </nav> */}
        </div>
        <section class="section">
          <div class="card p-2">
            <div class="parent col-md-12 row mt-2">
              <div class="col-md-4">
                <div class="child">
                  <input
                    id="myInput"
                    type="text"
                    style={{
                      borderRadius: "5px",
                      height: "35px",
                      padding: "10px",
                      border: "1px solid lightgrey ",
                    }}
                    onChange={handleSearchChange}
                    value={searchQuery}
                    placeholder="Search..."
                  />
                </div>
              </div>
              <div class="col-md-3">
                <Select
                  options={type}
                  value={selectedType}
                  onChange={(selectedOption) => setSelectedType(selectedOption)}
                  placeholder="Select Type"
                />
              </div>
              <div class="col-md-6" style={{ textAlign: "right" }}>
                <div class="child">
                  <a>
                    {" "}
                    {/* <button
                      id="btnNewUser"
                      type="button"
                      data-toggle="modal"
                      data-target="#modalAdd"
                      class=" btn-round"
                      onClick={openAdd_pages}
                    >
                      <i class="bi bi-person-add"></i> Add Pages
                    </button> */}
                  </a>
                </div>
              </div>
            </div>

            <div
              style={{ marginTop: "50px", display: "flex", marginLeft: "50%" }}
            >
              {/* <TailSpin color="black" width={50} /> */}
            </div>
            {/* <table class="table table-striped  ">
              <thead>
                <tr>
                  <th scope="col">Sr.No</th>
                  <th scope="col">Name</th>
                  <th scope="col">Date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">1</th>
                  <td>Mark</td>
                  <td>Otto</td>
                </tr>
                <tr>
                  <th scope="row">2</th>
                  <td>Jacob</td>
                  <td>Thornton</td>
                </tr>
                <tr>
                  <th scope="row">3</th>
                  <td>Mark</td>
                  <td>Otto</td>
                </tr>
              </tbody>
            </table> */}

            {isLoading === true ? (
              <div style={{ marginTop: "50px", marginLeft: "50%" }}>
                <TailSpin color="black" width={50} />
              </div>
            ) : question.length > 0 ? (
              <table class="table table-striped  ">
                <thead>
                  <tr>
                    <th scope="col">Sr. No.</th>
                    <th scope="col">Questions</th>
                    <th scope="col">Listing Details</th>
                    <th scope="col">Type</th>
                    <th scope="col">Customer Details</th>
                    <th scope="col">Instructor Details</th>
                    <th scope="col">Date</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody id="tableBody">
                  {filteredQuestions.map((q, index) => (
                    <tr key={q.id}>
                      <th scope="row">{index + 1}</th>
                      <td>
                        {q.question}
                        <br />
                      </td>
                      {/* <td>
                        <b>
                          {q.question_for === "Venue"
                            ? ` ${
                                q.venue
                                  ? q.venue.name || "No Venue Name"
                                  : "No Venue Assigned"
                              } - ${
                                q.venue
                                  ? q.venue.short_description ||
                                    "No Description"
                                  : "No Description"
                              }`
                            : q.question_for === "Workshop"
                            ? ` ${
                                q.workshop
                                  ? q.workshop.name || "No Workshop Name"
                                  : "No Workshop Assigned"
                              } - ${
                                q.workshop
                                  ? q.workshop.short_description ||
                                    "No Description"
                                  : "No Description"
                              }`
                            : "No Name"}
                        </b>
                      </td> */}
                      <td>
                        {q.question_for === "Venue" ? (
                          <>
                            {q.venue
                              ? `${q.venue.name || "-"} - ${
                                  q.venue.short_description || "-"
                                }`
                              : "-"}
                          </>
                        ) : q.question_for === "Workshop" ? (
                          <>
                            {q.workshop
                              ? `${q.workshop.name || "-"} - ${
                                  q.workshop.short_description ||
                                  "-"
                                }`
                              : "-"}
                          </>
                        ) : q.question_for === "News" ? (
                          <>
                            {q.news
                              ? `${q.news.title || "-"}`
                              : "-"}
                          </>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>
                        {q.question_for || "-"}
                        <br />
                      </td>
                      {/* <td>
                        <b>
                          {q.sender
                            ? ` ${q.sender.name || "No Name"}
                               ${q.sender.email || "No Email"}`
                            : "No Sender Details"}
                        </b>
                      </td> */}
                      {/* <td>
                        <b
                          dangerouslySetInnerHTML={{
                            __html: q.sender
                              ? `${q.sender.name || "No Name"}<br />
                              ${q.sender.email || "No Email"}`
                              : "No Sender Details",
                          }}
                        />
                      </td> */}
                      <td
                        dangerouslySetInnerHTML={{
                          __html: q.sender
                            ? `${q.sender.name || "-"}<br />${
                                q.sender.email || "-"
                              }<br />${
                                q.sender.mobileNumber || "-"
                              }`
                            : "-",
                        }}
                      />

                      <td
                        dangerouslySetInnerHTML={{
                          __html: q.sender
                            ? `${q.receiver.name || "-"}<br />${
                                q.receiver.email || "-"
                              }<br />`
                            : "-",
                        }}
                      />
                      <td>{formatCreatedAt(q.created_at)}</td>
                      <td>
                        <div className="social-links mt-2">
                          <a
                            onClick={() => openQuestionReply(q.id)}
                            style={{ cursor: "pointer" }}
                          >
                            <i class="bi bi-reply"></i>
                          </a>
                          &nbsp;&nbsp;
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <h3 style={{ textAlign: "center" }}> No data available </h3>
            )}
          </div>
          <div>
            {" "}
            <p
              style={{
                backgroundColor: "#000",
                color: "white",
                padding: "10px",
              }}
            >
              {filteredQuestions.length} Total
            </p>
          </div>
        </section>
      </main>
      <Footer></Footer>
    </div>
  );
}

export default Question;
